// Blog content — "Stories from the work". Case-study deep-dives, project
// notes, research, product, engineering — all by the Lincoln team.

import saleemPhoto from '../assets/images/saleem.png';

export const BLOG_POSTS = [
  {
    slug: 'malta-national-rollout',
    title: 'How we rolled Lincoln out to every Maltese high school in 12 months',
    excerpt: 'What it took to deploy a voice-AI tutor into 10 schools across an entire country — and what we learned in the process.',
    category: 'Case Study', cat_color: 'var(--blue)',
    author: 'Saleem Qureshi', author_role: 'Co-founder, CEO',
    date: 'May 18, 2026', read: '12 min',
    img: 'blog-malta', tag: '🇲🇹 Malta',
    photo: 'https://images.unsplash.com/photo-1523240795612-9a054b0db644?w=1000&auto=format&fit=crop&q=80',
    authorPhoto: saleemPhoto,
  },
  {
    slug: 'wef-launch',
    title: 'Behind the scenes: launching AI Literacy 101 with the World Economic Forum',
    excerpt: 'Three months from handshake to live course in 9 languages. The decisions, the trade-offs, the lessons.',
    category: 'Project Notes', cat_color: 'var(--green-2)',
    author: 'Aisha Saleem', author_role: 'Co-founder, COO',
    date: 'May 04, 2026', read: '9 min',
    img: 'blog-wef', tag: '🌐 Global',
    photo: 'https://images.unsplash.com/photo-1577896851231-70ef18881754?w=800&auto=format&fit=crop&q=80',
    authorPhoto: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=200&auto=format&fit=crop&q=80',
  },
  {
    slug: 'finland-glowie',
    title: 'Tutoring every Finnish high-schooler — the Glowie partnership',
    excerpt: "Why Finland's after-school tutoring program chose voice-first. The data after 6 months.",
    category: 'Case Study', cat_color: 'var(--blue)',
    author: 'Jukka Heikkinen', author_role: 'Partnerships, Nordics',
    date: 'Apr 28, 2026', read: '7 min',
    img: 'blog-finland', tag: '🇫🇮 Finland',
    photo: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=800&auto=format&fit=crop&q=80',
    authorPhoto: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=200&auto=format&fit=crop&q=80',
  },
  {
    slug: 'us-vocational',
    title: 'Vocational training in California: 8,400 learners, 16 trades',
    excerpt: 'How we adapted Lincoln for hands-on trades — from electrical to HVAC — in partnership with the City of Fontana.',
    category: 'Case Study', cat_color: 'var(--blue)',
    author: 'Sofia Lopez', author_role: 'Partnerships, Americas',
    date: 'Apr 21, 2026', read: '10 min',
    img: 'blog-us', tag: '🇺🇸 USA',
    photo: 'https://images.unsplash.com/photo-1565891741441-64926e441838?w=800&auto=format&fit=crop&q=80',
    authorPhoto: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&auto=format&fit=crop&q=80',
  },
  {
    slug: 'tutoring-at-scale',
    title: '12,000 students, one tutor: scaling 1-on-1 voice tutoring globally',
    excerpt: 'How Lincoln replicates the impact of a great human tutor — without breaking the per-student economics.',
    category: 'Project Notes', cat_color: 'var(--green-2)',
    author: 'Hassan Raza', author_role: 'Curriculum Engineer',
    date: 'Apr 12, 2026', read: '8 min',
    img: 'blog-tutoring', tag: '🌍 Global',
    photo: 'https://images.unsplash.com/photo-1531545514256-b1400bc00f31?w=800&auto=format&fit=crop&q=80',
    authorPhoto: 'https://images.unsplash.com/photo-1507591064344-4c6ce005b128?w=200&auto=format&fit=crop&q=80',
  },
  {
    slug: 'finland-ai-program',
    title: "Finland's national AI program: teaching every student, every age",
    excerpt: 'From age 7 to 18, in Finnish, Swedish, and English. The pedagogy behind a 12-year curriculum.',
    category: 'Case Study', cat_color: 'var(--blue)',
    author: 'Maria Eriksson', author_role: 'Curriculum Lead',
    date: 'Apr 03, 2026', read: '11 min',
    img: 'blog-finland-ai', tag: '🇫🇮 Finland',
    photo: 'https://images.unsplash.com/photo-1571260899304-425eee4c7efc?w=800&auto=format&fit=crop&q=80',
    authorPhoto: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200&auto=format&fit=crop&q=80',
  },
  {
    slug: 'voice-curriculum-design',
    title: 'Designing curricula for voice: what we changed',
    excerpt: "Reading and listening are different cognitive modes. Here's what our pedagogy team rewrote when we went voice-first.",
    category: 'Research', cat_color: '#7a3a8a',
    author: 'Maria Eriksson', author_role: 'Curriculum Lead',
    date: 'Mar 22, 2026', read: '13 min',
    img: 'blog-curriculum', tag: '📚 Pedagogy',
    photo: 'https://images.unsplash.com/photo-1497486751825-1233686f5d54?w=800&auto=format&fit=crop&q=80',
    authorPhoto: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200&auto=format&fit=crop&q=80',
  },
  {
    slug: 'qr-certs-blockchain',
    title: "Why our certificates have QR codes (and what's behind them)",
    excerpt: "Verifying credentials at scale — and the case for blockchain anchoring for high-stakes certs.",
    category: 'Product', cat_color: 'var(--yellow-2)',
    author: 'Tomi Lehto', author_role: 'Head of Engineering',
    date: 'Mar 14, 2026', read: '6 min',
    img: 'blog-qr', tag: '🏅 Credentials',
    photo: 'https://images.unsplash.com/photo-1606159068539-43f36b99d1b2?w=800&auto=format&fit=crop&q=80',
    authorPhoto: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=200&auto=format&fit=crop&q=80',
  },
  {
    slug: 'multilingual-voice',
    title: "Speaking 3 languages: how we built Lincoln's voice stack",
    excerpt: 'Code-switching mid-sentence, accent adaptation, and why we trained from scratch on Maltese.',
    category: 'Engineering', cat_color: '#c97864',
    author: 'Ari Mäkelä', author_role: 'Voice AI Lead',
    date: 'Feb 28, 2026', read: '14 min',
    img: 'blog-multi', tag: '🌐 Multilingual',
    photo: 'https://images.unsplash.com/photo-1530538987395-032d1800fdd4?w=800&auto=format&fit=crop&q=80',
    authorPhoto: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&auto=format&fit=crop&q=80',
  },
];

export const BLOG_CATEGORIES = [
  { name: 'All',           count: 47 },
  { name: 'Case Study',    count: 18 },
  { name: 'Project Notes', count: 12 },
  { name: 'Research',      count: 8 },
  { name: 'Product',       count: 6 },
  { name: 'Engineering',   count: 3 },
];
